import { render, staticRenderFns } from "./BoardDetailVisitor.vue?vue&type=template&id=5ab389f3&scoped=true"
import script from "./BoardDetailVisitor.vue?vue&type=script&lang=js"
export * from "./BoardDetailVisitor.vue?vue&type=script&lang=js"
import style0 from "./BoardDetailVisitor.vue?vue&type=style&index=0&id=5ab389f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab389f3",
  null
  
)

export default component.exports